import * as React from  'react'

export const ResumeContext = React.createContext({
    data:{},
    setData : ()=>{},
})